import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51359ed8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xrpage" }
const _hoisted_2 = {
  key: 0,
  class: "overlay"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Start XR")

import { computed } from 'vue';
import XRSync from '@/components/XRSync.vue';
import GLView from '@/components/GLView.vue';
import XREnding from '@/components/XREnding.vue';
import XRQuit from '@/components/XRQuit.vue';
import XRActivityDebugView from '@/components/XRActivityDebugView.vue';
import { useAppState, useGameState, useXrState } from '@/services/composition';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const xrstate = useXrState()
const gameState = useGameState()
const { state, send } = useAppState()

const DEBUG = computed(() => {
  return !!(process.env.VUE_APP_DEBUG?.toLowerCase?.() === 'true' || process.env.VUE_APP_DEBUG === true)
})

const leftXRInGame = computed(() => {
  return (
    xrstate.value.matches('inactive') && 
    !state.value.matches('sync') &&
    (gameState.value.matches('game') || gameState.value.matches('intro') || gameState.value.matches('tuto'))
  )
})

return (_ctx: any,_cache: any) => {
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "long-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(GLView, { class: "glview" }),
        (!_unref(DEBUG))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        (!_unref(leftXRInGame) && _unref(xrstate).matches('inactive') && !_unref(state).matches('sync'))
          ? (_openBlock(), _createBlock(_component_ui_btn, {
              key: 1,
              class: "btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)('REQUEST_SESSION')))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(state).matches('sync'))
          ? (_openBlock(), _createBlock(XRSync, { key: 2 }))
          : (_unref(gameState).matches('end.initial') || _unref(gameState).matches('end.success'))
            ? (_openBlock(), _createBlock(XREnding, { key: 3 }))
            : _createCommentVNode("", true),
        (_unref(leftXRInGame))
          ? (_openBlock(), _createBlock(XRQuit, { key: 4 }))
          : _createCommentVNode("", true),
        (_unref(DEBUG))
          ? (_openBlock(), _createBlock(XRActivityDebugView, {
              key: 5,
              class: "debug"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})